/** Знак приложения τ — тот же, что на иконке PWA (frontend/scripts/icons.mjs). */
export function BrandMark({ size = 28 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true" focusable="false">
      <rect width={32} height={32} rx={8} fill="var(--accent)" />
      <path
        transform="translate(-1.6 -1.6) scale(1.1)"
        d="M8.1 11.8C8.9 10.5 9.9 9.9 11.4 9.9H23.3M16.3 9.9V19.2C16.3 21.5 17.4 22.6 19.3 22.6C20.2 22.6 21 22.3 21.7 21.7"
        fill="none"
        stroke="var(--accent-fg)"
        strokeWidth={2.6}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
